<template>
    <div>
        <div class="flex gap-2 w-full">
            <div v-for="(n, index) in code" :key="'code_' + index" :class="['w-[50px] text-center', {
                'mr-2': index === 2,
                'ml-2': index === 3,
            }]">
                <vx-input
                    ref="inputs"
                    type="tex"
                    size="lg"
                    inputmode="numeric"
                    :ariaInvalid="index === 0 && props.error ? true : undefined"
                    pattern="\d*"
                    :maxlength="1"
                    v-model="code[index]"
                    @input="onInput($event, index)"
                    @keypress="validateKeyPress"
                    @keydown.delete="onDelete($event, index)"
                    @paste="onPaste"
                    class="text-center"
                />
            </div>
        </div>
        <span v-if="props.error" class="w-full mt-2 px-0.5 text-xs text-rose-800">
           {{ props.error }}
        </span>
    </div>
</template>

<script setup>
import { VxInput } from '@voxie/frontend-components';
import { computed, nextTick, ref, watch } from 'vue';

const props = defineProps({
    error: String,
});

const inputs = ref([]);

defineExpose({
    inputs
});

const model = defineModel();

const keysAllowed = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'Enter'];

const code = ref([null, null, null, null, null, null]);
const token = computed(() => code.value.join(''));

watch(token, () => {
    model.value = token.value;
});

const validateKeyPress = (event) => {
    const keyPressed = event.key;
    if (!keysAllowed.includes(keyPressed)) {
        event.currentTarget.value = '';
        event.preventDefault();
    }
};

const onInput = (event, index) => {
    if (event.inputType === 'insertText') {
        inputs.value[index + 1]?.field.focus();
    }
};

const onDelete = async (event, index) => {
    event.preventDefault();
    code.value[index] = '';
    await nextTick();
    inputs.value[index - 1]?.field.focus();
};

const onPaste = async (event) => {
    event.preventDefault();
    const pasted = (event).clipboardData
        ?.getData('text')
        .trim()
        .split('')
        .filter(value => keysAllowed.includes(value))
        .slice(0, 6);

    pasted.forEach((number, index) => {
        code.value[index] = number;
    });

    await nextTick();

    if (pasted.length >= 6) {
        inputs.value[inputs.value.length - 1].field.focus();
    } else {
        inputs.value[pasted.length].field.focus();
    }
};
</script>
